export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-scale/src/number.js
// module id = 152
// module chunks = 0 1 2 3 4